import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=cb80df9a&"
import script from "./FormSettings.vue?vue&type=script&lang=js&"
export * from "./FormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb80df9a')) {
      api.createRecord('cb80df9a', component.options)
    } else {
      api.reload('cb80df9a', component.options)
    }
    module.hot.accept("./FormSettings.vue?vue&type=template&id=cb80df9a&", function () {
      api.rerender('cb80df9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/FormSettings.vue"
export default component.exports